import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import {
    restorePasswordSecondStep,
    changeVisibleRestorePasswordSecondStep
} from '../../actions/User';
import qs from "qs";

const defaultProps = {
    closeModal: closeModal => {
    }
};

class RestorePasswordSecondStep extends Component {
    constructor(props) {
        super(props);

        const params = qs.parse(this.props.location.search.substring(1));
        this.state = {
            key: params.key
        }

        this.handleRestorePassword = this.handleRestorePassword.bind(this)
    }

    closeModal(event) {
        event.preventDefault();

        this.props.changeVisibleRestorePasswordSecondStep(false);
    }


    handleRestorePassword(event) {
        event.preventDefault();

        this.props.restorePasswordSecondStep(this.password.value, this.state.key);
        this.props.changeVisibleRestorePasswordSecondStep(false);
    }

    render() {
        const i18n = this.props.i18n;
        const key = this.state.key

        return (
            <ReactModal
                className="popup enter"
                overlayClassName="popup-overlay"
                isOpen={this.props.isShowRestorePasswordSecondStep}
            >
                <div onClick={(event) => this.closeModal(event)} className="popup-close"/>
                <div className="popup-title">
                    Change Password
                </div>

                <form>
                    <input
                        type="key"
                        placeholder="SecretKey"
                        className="text-field"
                        value={key}
                        disabled
                    />

                    <input
                        type="password"
                        placeholder="Place here your new Password"
                        className="text-field"
                        ref={ref => {
                            this.password = ref
                        }}
                    />

                    <div className="submit-box">
                        <button className="btn" type="submit" onClick={::this.handleRestorePassword}>
                            Change
                        </button>
                    </div>
                </form>
            </ReactModal>
        )
    }
}

RestorePasswordSecondStep.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    isShowRestorePasswordSecondStep: state.user.isShowRestorePasswordSecondStep,
    isShowWrongDataMessage: state.user.isShowWrongDataMessage
});

const mapDispatchToProps = {
    restorePasswordSecondStep,
    changeVisibleRestorePasswordSecondStep
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RestorePasswordSecondStep));



// WEBPACK FOOTER //
// ./src/components/Base/RestorePasswordSecondStep.js